import { AccountReferralCodeData } from "@mezo/api"
import { createSlice } from "@reduxjs/toolkit"

export type ReferralState = {
  currentReferralCode: string | null
  referralCodes: AccountReferralCodeData[] | null
}

const initialState: ReferralState = {
  currentReferralCode: null,
  referralCodes: null,
}

const referralsSlice = createSlice({
  name: "referrlas",
  initialState,
  reducers: {
    setReferralCodes: (
      immerState,
      { payload }: { payload: AccountReferralCodeData[] },
    ) => {
      immerState.referralCodes = payload
    },
    setCurrentReferralCode: (
      immerState,
      { payload }: { payload: string | null },
    ) => {
      immerState.currentReferralCode = payload
    },
  },
})

export const { setReferralCodes, setCurrentReferralCode } =
  referralsSlice.actions

export default referralsSlice.reducer
